import JSZip from 'jszip';
import { EncryptionNotSupportedError } from './exceptions/EncryptionNotSupportedError';
import { NoIMSManifestError } from './exceptions/NoIMSManifestError';
import mimeTypes from 'mime-types';

export class ScormInstance {
  jsZip;
  parser;

  zipFile;
  imsManifest;
  manifestFile;
  xml;

  validFileExtensions = ['html', 'htm'];

  constructor() {
    this.jsZip = new JSZip();
    this.parser = new DOMParser();
  }

  async loadZipFile(file) {
    return this.jsZip
      .loadAsync(file)
      .then(async zipFile => {
        this.zipFile = zipFile;
        this.imsManifest = this.getEntries().find(([key, value]) => key.includes('imsmanifest.xml'));

        if (!this.imsManifest) {
          throw new NoIMSManifestError('No imsmanifest.xml found');
        }

        this.manifestFile = await this.imsManifest[1].async('string');
        this.xml = this.parser.parseFromString(this.manifestFile, 'text/xml');

        return this;
      })
      .catch(error => {
        if (error.message === 'Encrypted zip are not supported') {
          throw new EncryptionNotSupportedError('Encrypted zip are not supported');
        }
        throw error;
      });
  }

  getEntries() {
    return Object.entries(this.zipFile.files);
  }

  getWebItems() {
    const items = this.xml.getElementsByTagName('item');
    return Array.from(items);
  }

  getWebItemsByFileNames(fileNames) {
    return this.getWebItems().filter(item => fileNames.includes(this.getFileNameByItem(item)));
  }

  getWebResources() {
    const resources = this.xml.getElementsByTagName('resource');
    const resourcesArray = Array.from(resources);
    const resourcesFiltered = resourcesArray.filter(
      resource =>
        resource.getAttribute('type') === 'webcontent' &&
        resource.getAttribute('href') &&
        this.validFileExtensions.some(extension => resource.getAttribute('href').includes(extension))
    );
    return Array.from(resourcesFiltered);
  }

  getHTMLFileNames() {
    return this.getWebResources().map(resource => resource.getAttribute('href').split('?')[0]);
  }

  getHrefByFileName(fileName) {
    const resource = this.getWebResources().find(resource => resource.getAttribute('href').split('?')[0] === fileName);
    return resource.getAttribute('href');
  }

  getSCORMTitle() {
    return Array.from(this.xml.getElementsByTagName('title'))[0].textContent;
  }

  getTitleByItem(item) {
    return Array.from(item.getElementsByTagName('title'))[0].textContent;
  }

  getTitleByFileName(fileName) {
    return fileName.split('/').pop();
  }

  getFileNameByItem(item) {
    const identifier = item.getAttribute('identifierref');
    const resource = this.getWebResources().find(resource => resource.getAttribute('identifier') === identifier);

    if (resource) {
      return resource.getAttribute('href').split('?')[0];
    }

    return null;
  }

  getAdditionalQueryParamsByFileName(fileName) {
    const resource = this.getWebResources().find(resource => resource.getAttribute('href').split('?')[0] === fileName);
    return resource.getAttribute('href').split('?')[1];
  }

  async getFileFromEntry(zipEntry, fileName) {
    // Deberá asignar name, lastModifiedDate y type
    const file = await zipEntry.async('blob');
    file.name = fileName;
    file.lastModifiedDate = new Date();
    // No podemos asignar file.type porque no es un atributo de Blob con getter, así que lo hacemos de otra manera
    Object.defineProperty(file, 'type', {
      get: () => mimeTypes.lookup(fileName)
    });
    return file;
  }
}
